const prefix = "[SCHEDULER_DEFINITIONS]";

export default {
    FETCH_SCHEDULER_DEFINITIONS_REQUEST: `${prefix} FETCH_SCHEDULER_DEFINITIONS_REQUEST`,
    FETCH_SCHEDULER_DEFINITIONS_SUCCESS: `${prefix} FETCH_SCHEDULER_DEFINITIONS_SUCCESS`,
    FETCH_SCHEDULER_DEFINITIONS_FAILED: `${prefix} FETCH_SCHEDULER_DEFINITIONS_FAILED`,
    CREATE_SCHEDULER_RULE_REQUEST: `${prefix} CREATE_SCHEDULER_RULE_REQUEST`,
    CREATE_SCHEDULER_RULE_SUCCESS: `${prefix} CREATE_SCHEDULER_RULE_SUCCESS`,
    CREATE_SCHEDULER_RULE_FAILED: `${prefix} CREATE_SCHEDULER_RULE_FAILED`,
    UPDATE_SCHEDULER_RULE_REQUEST: `${prefix} UPDATE_SCHEDULER_RULE_REQUEST`,
    UPDATE_SCHEDULER_RULE_SUCCESS: `${prefix} UPDATE_SCHEDULER_RULE_SUCCESS`,
    UPDATE_SCHEDULER_RULE_FAILED: `${prefix} UPDATE_SCHEDULER_RULE_FAILED`,
    CANCEL_SCHEDULER_RULE_UPDATE: `${prefix} CANCEL_SCHEDULER_RULE_UPDATE`,
};
